import React, { memo, useState } from "react";
import MaterialTable from "material-table";
import Icon from "@jll/icon";
import { useTranslation } from "react-i18next";
import { withStyles, IconButton, Tooltip, Paper } from "@material-ui/core";

// Custom Components
import CustomMTableHeader from "../../../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../../../Component/Table/CustomMTableCell";
import { Pagination } from "../../../../../../Component";
// Importing the component from Admin Audit as there is no change for this component
import AuditPopup from "../../../../../Admin/Component/AuditInfo/Components/AuditPopup";

// Other
import {
  tableOptions,
  tableIcons,
  tableStyle,
} from "../../../../../../Component/Table/tableCommonStyles";
import { styles } from "./styles";
import { TableHeader } from "./tableHeader";

const AuditTable = (props) => {
  const [selectedRecord, setSelectedRecord] = useState({});
  const [viewDialogOpen, setViewDialogOpen] = useState(false);

  const { t } = useTranslation();

  const {
    classes,
    records = [],
    handlePageSizeChange,
    rowsPerPage,
    pageNumber,
    handlePageChange,
    totalItemsCount,
    loading
  } = props;

  const viewRecord = (record) => {
    setSelectedRecord(record);
    setViewDialogOpen(true);
  };

  return (
    <div className={classes.checksTableContainer}>
      <MaterialTable
        isLoading={loading}
        style={tableStyle}
        icons={tableIcons}
        elevation="0"
        options={tableOptions}
        data={records}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
          },
        }}
        columns={TableHeader(t)}
        actions={[
          {
            icon: "next",
            position: "row",
            onClick: (event, record) => {
              viewRecord(record);
            },
          },
        ]}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />,
          Action: (props) => {
            switch (props.action.icon) {
              case "next":
                return (
                  <Tooltip
                    title={t("labels.audit.table.actions.viewDetails")}
                    placement="bottom"
                  >
                    <IconButton
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                      className={classes.actionIcons}
                    >
                      <Icon className="far fa-eye" style={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                );
              default:
                return null;
            }
          },
          Header: (props) => <CustomMTableHeader {...props} />,
          Row: (props) => <CustomMTableRow {...props} />,
          Cell: (props) => <CustomMTableCell {...props} />,
        }}
      />
      <Pagination
        handleRowsPerPage={handlePageSizeChange}
        rowsPerPage={rowsPerPage}
        pageNumber={pageNumber}
        handlePagination={handlePageChange}
        totalItemsCount={totalItemsCount}
      ></Pagination>

      <AuditPopup
        open={viewDialogOpen}
        record={selectedRecord}
        onClose={() => setViewDialogOpen(false)}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(memo(AuditTable));
